import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormCheck,
    ReactHookFormInput,
    ReactHookFormToggleButtonGroupV2,
} from 'common/components/form';

import { TAX_TYPES } from '../constants';

const TaxField = ({ control }) => {
    const { t } = useTranslation();

    const [taxIncluded, taxType] = useWatch({
        control,
        name: ['tax_included', 'tax_type'],
    });

    return (
        <Grid container>
            <ReactHookFormCheck control={control} name="tax_included" />

            <Grid size="grow">
                <ReactHookFormInput
                    append={taxType === TAX_TYPES.PERCENTAGE ? '%' : 'MXN'}
                    control={control}
                    disabled={!taxIncluded}
                    label={t('Tax')}
                    name="tax_value"
                    onlyNumbers={true}
                    prepend={taxType === TAX_TYPES.AMOUNT ? '$' : ''}
                    type="text"
                />
            </Grid>

            <Grid size="auto">
                <ReactHookFormToggleButtonGroupV2
                    control={control}
                    disabled={!taxIncluded}
                    fullWidth
                    name="tax_type"
                    options={[
                        { label: '%', value: TAX_TYPES.PERCENTAGE },
                        { label: '$', value: TAX_TYPES.AMOUNT },
                    ]}
                    sx={{ minWidth: '120px' }}
                />
            </Grid>
        </Grid>
    );
};

TaxField.propTypes = {
    control: PropTypes.object,
};

export default TaxField;
